import { isAldeiaAtom, isMobileAtom } from "atoms/app.atom"
import { useAtom } from "jotai"
import { getHost } from "lib/helper"
import { useEffect } from "react"

export let IS_AGENT_APP = getHost()?.subdomain == "agents" || window.location.host.includes("aldeia.so")
export let isAldeia = import.meta.env.VITE_ALDEIA === "true" || IS_AGENT_APP

export async function loadAldeiaFonts() {
  // await import("../styles/fonts.css")
}

export const useAldeia = () => {
  const [isAldeiaLocal, setIsAldeiaLocal] = useAtom(isAldeiaAtom)
  const [isMobile] = useAtom(isMobileAtom)

  useEffect(() => {
    if (isAldeiaLocal && !isMobile) {
      isAldeia = true
      document.body.classList.remove("kinbox")
      document.body.classList.add("aldeia")
      if (IS_AGENT_APP) {
        document.body.classList.add("agents")
      }

      // Theme
      // document.body.style.setProperty("--base-200", "#f5f5f5")
      // document.body.style.setProperty("--header-height", "48px")
      document.body.style.setProperty("--actionable-button-fill", "var(--selected)")
      // document.body.style.setProperty("--content-secondary", "var(--selected)")
    } else {
      isAldeia = false
      document.body.classList.add("kinbox")
      document.body.classList.remove("aldeia")
      document.body.style.removeProperty("--actionable-button-fill")
    }
  }, [isAldeiaLocal, isMobile])

  return {
    isAldeiaLocal,
  }
}
